<script setup lang="ts">
import { useModalStore } from "@/stores/modalStore.ts";

const modal = useModalStore();
</script>

<template>
  <v-dialog
    :model-value="modal.isOpen"
    :max-width="modal.maxWidth"
    :persistent="modal.persistent"
    @update:model-value="!$event && modal.closeModal(false)"
  >
    <component
      :is="modal.component"
      v-bind="modal.props"
      @close-modal="modal.closeModal"
      class="mx-auto w-100"
    />
  </v-dialog>
</template>
